import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { useActivation } from '@/hooks/view-model-hooks'
import { useSideSheet } from '@/components/SideSheet'
import { type WorkspacePostingOpportunitiesViewModel } from '@/features/opportunities/workspace-postings-opportunities/WorkspacePostingOpportunitiesViewModel'
import { WorkspaceOpportunitiesMainView } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunities'
import { WorkspaceOpportunitiesListContainer } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunitiesList/WorkspaceOpportunitiesListContainer'
import { WorkspaceOpportunityDetailsSheetContainer } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunityDetailsSheet/WorkspaceOpportunityDetailsSheetContainer'

export interface WorkspaceOpportunitiesMainViewContainerProps {
  vm: WorkspacePostingOpportunitiesViewModel
  tabBars: ReactNode
}

export const WorkspaceOpportunitiesMainViewContainer = observer(
  function WorkspaceOpportunitiesMainViewContainer({
    vm,
    tabBars,
  }: WorkspaceOpportunitiesMainViewContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    useActivation(vm)
    const sideSheet = useSideSheet()

    return (
      <WorkspaceOpportunitiesMainView
        tabBars={tabBars}
        sheetVisible={!!vm.detailsVm.selected || !sideSheet.shouldBeAbove}
        sheetElevation={sideSheet.elevation}
        onRequestHideSheet={vm.detailsVm.deselect}
        resultCount={vm.opportunities.length}
        corporateMode={shellInfo.corporateMode}
        list={<WorkspaceOpportunitiesListContainer vm={vm} />}
        detailsSheet={
          <WorkspaceOpportunityDetailsSheetContainer
            vm={vm.detailsVm}
            onClose={
              sideSheet.elevation === 'above'
                ? vm.detailsVm.deselect
                : undefined
            }
          />
        }
      />
    )
  },
)
